import React from "react";

const DiscardedBig = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_3578_12)">
      <rect x="4" y="4" width="24" height="24" rx="4" fill="#FFE4E6" />
    </g>
    <path
      d="M17.4097 15.9991L21.7061 11.7127C21.8943 11.5245 22 11.2693 22 11.0033C22 10.7372 21.8943 10.482 21.7061 10.2938C21.518 10.1057 21.2628 10 20.9967 10C20.7306 10 20.4755 10.1057 20.2873 10.2938L16.0009 14.5903L11.7144 10.2938C11.5262 10.1057 11.2711 10 11.005 10C10.7389 10 10.4837 10.1057 10.2956 10.2938C10.1074 10.482 10.0017 10.7372 10.0017 11.0033C10.0017 11.2693 10.1074 11.5245 10.2956 11.7127L14.592 15.9991L10.2956 20.2856C10.2019 20.3785 10.1276 20.489 10.0768 20.6108C10.0261 20.7325 10 20.8631 10 20.995C10 21.1269 10.0261 21.2575 10.0768 21.3793C10.1276 21.501 10.2019 21.6116 10.2956 21.7044C10.3884 21.7981 10.499 21.8724 10.6207 21.9232C10.7425 21.9739 10.8731 22 11.005 22C11.1369 22 11.2675 21.9739 11.3892 21.9232C11.511 21.8724 11.6215 21.7981 11.7144 21.7044L16.0009 17.408L20.2873 21.7044C20.3802 21.7981 20.4907 21.8724 20.6125 21.9232C20.7342 21.9739 20.8648 22 20.9967 22C21.1286 22 21.2592 21.9739 21.381 21.9232C21.5028 21.8724 21.6133 21.7981 21.7061 21.7044C21.7998 21.6116 21.8741 21.501 21.9249 21.3793C21.9756 21.2575 22.0017 21.1269 22.0017 20.995C22.0017 20.8631 21.9756 20.7325 21.9249 20.6108C21.8741 20.489 21.7998 20.3785 21.7061 20.2856L17.4097 15.9991Z"
      fill="#961B01"
    />
    <defs>
      <filter
        id="filter0_d_3578_12"
        x="0"
        y="0"
        width="32"
        height="32"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3578_12"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3578_12"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default DiscardedBig;
